import { render } from "./MotorDtl.vue?vue&type=template&id=bf608f18&scoped=true"
import script from "./MotorDtl.vue?vue&type=script&lang=js"
export * from "./MotorDtl.vue?vue&type=script&lang=js"

import "./MotorDtl.vue?vue&type=style&index=0&id=bf608f18&lang=css&scoped=true"
import "@/assets/css/style_parts.css?vue&type=style&index=1&id=bf608f18&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=2&id=bf608f18&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf608f18"]])

export default __exports__